const adminCardsData = [
  {
    icon: 'Users',
    title: 'View users',
    text: 'Explore detailed information about all users in the system and manage their profiles efficiently.',
    button: {
      title: 'Start now',
      style: 'tertiary',
      link: '/users',
      icon: 'ArrowRight',
      animation: 'move-right'
    }
  },
  {
    icon: 'Users',
    title: 'Create user',
    text: 'Add new users to your system and manage their account specifications.',
    button: {
      title: 'Start now',
      style: 'tertiary',
      link: '/users/create',
      icon: 'ArrowRight',
      animation: 'move-right'
    }
  },
  {
    icon: 'Users',
    title: 'Delete user',
    text: 'Remove users from your system and keep your user base up-to-date.',
    button: {
      title: 'Start now',
      style: 'tertiary',
      link: '/users',
      icon: 'ArrowRight',
      animation: 'move-right'
    }
  },
];

export default adminCardsData;



